import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {DiDate} from 'app/blocks/util/di-date';

export interface IExchangeRate extends IBaseEntity {
    id?: number;
    effectiveFrom?: any;
    conversion?: number;
    fromCurrencyId?: number;
    toCurrencyId?: number;
    toCurrencyName?: string;
    fromCurrencyName?: string;
}

export class ExchangeRate extends BaseEntity implements IExchangeRate {
    public id: number;
    public effectiveFrom: any;
    public conversion: number;
    public fromCurrencyId: number;
    public toCurrencyId: number;
    public toCurrencyName?: string;
    public fromCurrencyName?: string;

    constructor(exchangeRate?: any) {
        super();
        if (exchangeRate) {
            this.id = exchangeRate.id;
            this.effectiveFrom = DiDate.newInstance(exchangeRate.effectiveFrom);
            this.conversion = exchangeRate.conversion;
            this.fromCurrencyId = exchangeRate.fromCurrencyId;
            this.toCurrencyId = exchangeRate.toCurrencyId;
            this.toCurrencyName = exchangeRate.toCurrencyName;
            this.fromCurrencyName = exchangeRate.fromCurrencyName;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): ExchangeRate {
        return new ExchangeRate(this);
    }
}
